import React from 'react';
import './home.scss';
import logo from '../../img/LogoR3.png';

import {Logout, IsRole_Manager, IsRole_Operator} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 


//import { AuthProvider, useAuth } from '../../contexts/auth';
export default function Home() {

  //const authProvider = useAuth();
  //console.log(authProvider);

  const { user } = useAuth(); 

  if (!user) 
    Logout();
  else
  {
    //console.log('Token:' + user.token);
    console.log('Username:' + user.username);

    const isManager =IsRole_Manager();
    console.log('IsManager: ' + isManager);

    const isOperator=IsRole_Operator();
    console.log('IsOperator: ' + isOperator);
  } 


  return (
    <React.Fragment>
      <h2 className={'content-block'}>RIBER Italia Srl</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
          <div className={'logos-container'} >            
            <img
            alt={''}
            src={logo}
            />
      
          </div>

          <p>Via S. Martino, 11 26900 Lodi (LO).</p>
          <small>Applicazione in <b>{process.env.NODE_ENV}</b> mode.</small>
          <p><small>Versione <b>1.7.6 21-06-2026</b></small></p>
          
          
        </div>
      </div>
    </React.Fragment>
)}
